function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#747474",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  transform: "translate(1 1)"
}, React.createElement("path", {
  d: "M27.3 22.527H4.71c-.383 0-.637-.254-.637-.636V4.645c0-.381.254-.636.636-.636h22.655c.381 0 .636.255.636.636v17.246c-.064.318-.318.636-.7.636z"
}), React.createElement("path", {
  d: "M4.01 20.49l-1.846.128c-.382 0-.764-.254-.764-.636L0 2.99c0-.382.255-.764.636-.764l22.4-1.845c.382 0 .764.254.764.636l.255 2.927"
}), React.createElement("circle", {
  cx: 16.609,
  cy: 9.927,
  r: 1.782
}), React.createElement("path", {
  d: "M4.073 17.945L12.473 11.964 21 19.282"
}), React.createElement("path", {
  d: "M16.609 15.527L19.727 12.855 27.618 19.282"
}));

const SvgComponent = props => React.createElement("svg", _extends({
  width: 30,
  height: 25,
  viewBox: "0 0 30 25"
}, props), _ref);

export default __webpack_public_path__ + "static/media/photographs.67116064.svg";
export { SvgComponent as ReactComponent };